import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import VueCookies from 'vue-cookies'
//state: time.toString(),

import VueAppleLogin from 'vue-apple-login'
Vue.use(VueAppleLogin, {
    clientId: 'com.dainls.youthnavi-web',
    scope: 'name email',
    redirectURI: 'https://www.youthnavi.net/youthnavi/signup/apple/login',
    state: 'login',
    usePopup: true,
});

import AppleLogin from './components/common/appleLogin.vue'
Vue.component('applelogin', AppleLogin);

Vue.use(VueCookies);

new Vue({
    el: '#scope-login',
    data: function() {
        return {
            passwordFieldType: 'password',
            modal_text:{
                title:'',
                contents:'',
            },
            err_id:'',
            err_pass:'',
            err_name:'',
            err_email:'',
            err_phone:'',
            err_dept:'',
            err_position:'',
            err_msg:'',
            isSendId:false,
            isAdmin:false,
            isLoginYn :false,
            saveYn : "N",
                    al: null,
                    isAndroid: false,
            viewModel: {
                totalCount: 0,
                list: [],
                listRoles: [],
                listUserTypeCodes: [],
                listUserStatusCodes: [],
                listPhoneCodes: [],
                listEmailCodes: [],
                detailUser: {user_type_code:'ACC_0001', user_roles:'ROLE_002', user_status_code:'ACC_ST04'},
                loginUser:{loginUserID:'', loginUserType:''},
                pwd1: "",
                pwd2: "",
                new_pwd1: "",
                new_pwd2: "",
                phone1: "010",
                phone2: "",
                phone3: "",
                email1: "",
                email2: "",
                emailAddr: "",
                isShowUserCreate: false,
                isEnableUpdate: false,
                checkedItem: [],
                isInitSystem: false,
                resultMessage: "",
                findOption: "user_name",
                findText: "",
                isShowMessage: false,
                isCheckedID: false,
                isCheckedEmail: false,
                regId : /^[A-Za-z0-9]{4,12}$/,
                regPass :  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/,
                regEmail :  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
                regPhone :  /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-[0-9]{3,4}-[0-9]{4}$/
            }
        }
    },
    mounted: function() {
        pageLoad(this);

        // 안드로이드 단말에서는 애플 로그인 버튼 숨기기
        this.$nextTick(() => {
            try {
                const ua = (navigator && (navigator.userAgent || navigator.vendor || window.opera)) || '';
                this.isAndroid = /Android/i.test(ua);
                if (this.isAndroid) {
                    // applelogin(ref="al") 다음에 배치된 실제 클릭용 앵커를 숨긴다
                    const appleRef = this.$refs && this.$refs.al;
                    const anchorEl = appleRef && appleRef.$el && appleRef.$el.nextElementSibling;
                    if (anchorEl && anchorEl.style) {
                        anchorEl.style.display = 'none';
                    }
                }
            } catch (e) {
                // no-op: UA 파싱 실패해도 앱 동작은 계속
                console.debug('Android UA detect error:', e);
            }
        });
    },
    methods: {
        resetUserId() {
          this.viewModel.detailUser.user_id = '';
        },
        switchVisibility() {
          this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
        },
        fnPageInit: function() {
            let vm = this;
            let _loginUserID = null;
            let _loginUserName = null;
            let _loginUserType = null;
            //  vm.fnGetPhoneCode();
            //  vm.fnGetEmailCode();

            if(vm.$cookies.isKey("userId")){
                let cookie = this.$cookies.get("userId");

                if(cookie != null && cookie != ""){
                    vm.saveYn = "Y";
                    vm.viewModel.detailUser.user_id = cookie;
                }
            }

            Axios.post("/api/admin/user/init/check", {})
            .then(function(response) {
                _loginUserID = response.data.commonParams.loginUserID;
                _loginUserName = response.data.commonParams.loginUserName;
                _loginUserType = response.data.commonParams.accType;


                if(_loginUserID != null){
                    vm.isLoginYn = true;
                    vm.viewModel.loginUser.loginUserID = _loginUserName;
                    vm.viewModel.loginUser.loginUserType = _loginUserType;
                }else{
                    vm.isLoginYn = false;
                    vm.viewModel.loginUser.loginUserID = '';
                    vm.viewModel.loginUser.loginUserType = '';
                }


                if(response.data.resultCount == 0){
                    vm.isAdmin = true;
                    alert("관리자 계정이 없습니다.\n관리자 계정을 생성하세요");
                }else{
                    vm.isAdmin = false;

                }
            }).catch(function(ex) {
                console.log(ex);
            });
        }
        ,fnGetPhoneCode:function(){
            let vm = this;
            Axios.post("/api/admin/code/sys/list", {paramCodeGrp : "TEL_EXCH"})
            .then(function(response) {
                vm.viewModel.listPhoneCodes = response.data.listCodeSys;
            }).catch(function(ex) {
                console.log(ex);
            });
        }
        ,fnGetEmailCode:function(){
            let vm = this;
            Axios.post("/api/admin/code/sys/list", {paramCodeGrp : "EMAIL_CD"})
            .then(function(response) {
                vm.viewModel.listEmailCodes = response.data.listCodeSys;

            }).catch(function(ex) {
                console.log(ex);
            });
        }
        , fnCickBtnLogin:function(){
        }

        ,fnOnClickBtnLogin: function() {
            let vm = this;

           let keyEx = $("#keyEx").val();
           let keyM = $("#keyM").val();

           let rsa = new RSAKey();


            rsa.setPublic(keyM,keyEx);



            vm.err_id='';
            vm.err_pass='';

            if(vm.viewModel.detailUser.user_id == null || vm.viewModel.detailUser.user_id == ""){
                vm.err_id = "아이디를 입력하세요";
                swal("아이디를 입력하세요").then(function() {
                  $('#login_id').focus();
                });
                return false;
            }


            if(vm.viewModel.detailUser.user_pwd == null || vm.viewModel.detailUser.user_pwd == ""){
                vm.err_pass = "비밀번호를 입력하세요";
              swal("비밀번호를 입력하세요").then(function() {
                $('#login_pw').focus();
              });
                return false;
            }


            let encID = rsa.encrypt(vm.viewModel.detailUser.user_id.trim());
            let encPwd = rsa.encrypt(vm.viewModel.detailUser.user_pwd.trim());

            $("#encUserID").val(encID);
            $("#encUserPwd").val(encPwd);

            if(vm.saveYn == "Y"){
                vm.$cookies.set("userId", vm.viewModel.detailUser.user_id, 60 * 60 * 25 * 30);
            }else if(vm.saveYn == "N"){
                vm.$cookies.remove("userId");
            }


            document.forms["mainForm"].submit();
        }
        ,fnOnCreateAdmin: function(){
            let vm = this;

            if(vm.viewModel.detailUser.user_id == null || vm.viewModel.detailUser.user_id == ""){
                vm.err_id = "아이디를 입력하세요";
                return false;
            }
            if(vm.viewModel.detailUser.user_pwd == null || vm.viewModel.detailUser.user_pwd == ""){
                vm.err_pass = "비밀번호를 입력하세요";
                return false;
            }

            Axios.post("/api/account/admin/create", {detail:vm.viewModel.detailUser})
            .then(function(response) {
                vm.fnPageInit();
            }).catch(function(ex) {
                console.log(ex);
            });
        }
        ,fnOnClickCheckID:function(){
            let vm = this;
            if(vm.viewModel.detailUser.user_id == null || vm.viewModel.detailUser.user_id==""){
                vm.err_id = "아이디를 입력하세요";
                return false;
            }else{
                if (!vm.viewModel.regId.test(vm.viewModel.detailUser.user_id)) {
                    vm.err_id = "영문,숫자를 포함한 4자이상12자 이하입니다.";
                    return false;
                }else{
                    Axios.post("/api/account/id/check",{paramUserID:vm.viewModel.detailUser.user_id})
                    .then(function(response) {
                        vm.err_id = "";
                        if(response.data.detail==null){
                            alert("사용 가능한 아이디 입니다.");
                            vm.viewModel.isCheckedID=true;
                        }
                        else {
                            alert("이미 사용중인 아이디 입니다.");
                            vm.viewModel.isCheckedID=false;
                        }
                    });
                }
            }
        }
        ,fnOnClickCheckEmail:function(){
            let vm = this;
            if(vm.viewModel.email1 == null || vm.viewModel.email1=="" || vm.viewModel.email2 == null || vm.viewModel.email2 == ""){
                vm.err_email = "이메일을 입력하세요";
                return false;
            }else{
                let paramEmail = vm.viewModel.email1+'@'+vm.viewModel.email2;
                Axios.post("/api/account/detail/email",{paramUserEmail:paramEmail})
                .then(function(response) {
                    if(response.data.detail==null){
                        alert("사용 가능한 이메일 입니다.");
                        vm.viewModel.isCheckedEmail=true;
                    }
                    else {
                        alert("이미 사용중인 이메일 입니다.");
                        vm.viewModel.isCheckedEmail=false;
                    }
                });
            }
        }

        ,fnOnClickMoveCheck : function(_value){
            window.location.href = "/youthnavi/signup/search/cert?encCase=" + _value;
        }
        , fnOnClickMovePasswordCheck:function(){
            window.location.href = "/nbig/login";
        }

        , fnOnChangeEmailAddr:function(){
            let vm = this;
            vm.viewModel.email2 = vm.viewModel.emailAddr;
            vm.viewModel.isCheckedEmail = false;
        }

        ,fnChangeValue: function(paramItem){
            let vm = this;
            if(paramItem == 'user'){
              vm.viewModel.isCheckedID = false;
            }else{
              vm.viewModel.isCheckedEmail = false;
            }
        }
        , fnOnClickFacebook:function(){
            location.href="/youthnavi/signup/facebook";
        }
        ,onSuccess(data) {
            console.log(data);
            this.signedIn = true;
        },
        onSuccessLogout(){
            this.signedIn = false;
        },
        onFailure(error) {
            console.log(error);
        },

        fnCheckBoxOnOff(){
            let vm = this;

            if(vm.saveYn == "Y"){
                vm.saveYn = "N";
            }else{
                vm.saveYn = "Y";
            }
        }

        , fnGotoPage(){
            let vm = this;

            location.href = "/";
        }
    }
});
